/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./operation-result-types";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const addConnection = /* GraphQL */ `mutation AddConnection(
  $from_user_id: String
  $relationship_id: Int!
  $status: String
  $to_user_id: String!
) {
  addConnection(
    from_user_id: $from_user_id
    relationship_id: $relationship_id
    status: $status
    to_user_id: $to_user_id
  ) {
    from_user_id
    relationship_id
    status
    to_user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddConnectionMutationVariables,
  APITypes.AddConnectionMutation
>;
export const deleteMessage = /* GraphQL */ `mutation DeleteMessage($pk: String!, $sk: String!) {
  deleteMessage(pk: $pk, sk: $sk) {
    content
    g_user_id
    input_tokens
    msg_type
    output_tokens
    pk
    sender
    session_id
    sk
    user_response
    vault_user_form_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMessageMutationVariables,
  APITypes.DeleteMessageMutation
>;
export const dropConnection = /* GraphQL */ `mutation DropConnection($from_user_id: String!, $to_user_id: String!) {
  dropConnection(from_user_id: $from_user_id, to_user_id: $to_user_id) {
    from_user_id
    relationship_id
    status
    to_user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DropConnectionMutationVariables,
  APITypes.DropConnectionMutation
>;
export const sendMessage = /* GraphQL */ `mutation SendMessage(
  $content: String!
  $g_user_id: String
  $input_tokens: Int
  $msg_type: String
  $output_tokens: Int
  $pk: String!
  $sender: String!
  $session_id: String
  $sk: String!
  $user_response: String
  $vault_user_form_id: String
) {
  sendMessage(
    content: $content
    g_user_id: $g_user_id
    input_tokens: $input_tokens
    msg_type: $msg_type
    output_tokens: $output_tokens
    pk: $pk
    sender: $sender
    session_id: $session_id
    sk: $sk
    user_response: $user_response
    vault_user_form_id: $vault_user_form_id
  ) {
    content
    g_user_id
    input_tokens
    msg_type
    output_tokens
    pk
    sender
    session_id
    sk
    user_response
    vault_user_form_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SendMessageMutationVariables,
  APITypes.SendMessageMutation
>;
export const updateConnection = /* GraphQL */ `mutation UpdateConnection(
  $from_user_id: String!
  $relationship_id: Int
  $reminder_count: Int
  $status: String
  $to_user_id: String!
) {
  updateConnection(
    from_user_id: $from_user_id
    relationship_id: $relationship_id
    reminder_count: $reminder_count
    status: $status
    to_user_id: $to_user_id
  ) {
    from_user_id
    relationship_id
    status
    to_user_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateConnectionMutationVariables,
  APITypes.UpdateConnectionMutation
>;
export const updateMessage = /* GraphQL */ `mutation UpdateMessage(
  $content: String!
  $pk: String!
  $sk: String!
  $user_response: String
) {
  updateMessage(
    content: $content
    pk: $pk
    sk: $sk
    user_response: $user_response
  ) {
    content
    g_user_id
    input_tokens
    msg_type
    output_tokens
    pk
    sender
    session_id
    sk
    user_response
    vault_user_form_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMessageMutationVariables,
  APITypes.UpdateMessageMutation
>;
